import React, { useState } from "react";
import { Checkbox, DropDown, RollingLoader } from "../commons";
import { countryCode } from "../../constant/countryCode";
import { DropDownType, UserDetailsType } from "./SignUpCard";

type AppProps = {
  countryDialCode: DropDownType;
  setCountryDialCode: (data: any) => void;
  setInputDetails: React.Dispatch<React.SetStateAction<UserDetailsType>>;
  inputDetails: UserDetailsType;
  onNext: (data:any) => void;
  mobileFetching: boolean;
  isMobileNo: number|null;
  mobileMessage: null | string;
  handleInputChange: (e: any) => void;
};

const CreateAccountWithOtp = ({
  countryDialCode,
  setCountryDialCode,
  setInputDetails,
  inputDetails,
  onNext,
  mobileFetching,
  isMobileNo,
  mobileMessage,
  handleInputChange,
}: AppProps) => {
  const [checkBox, setCheckBox] = useState<boolean>(false);
  const [showOtpVerification, setShowOtpVerification] = useState(true);
  const selectStyle = {
    option: (baseStyles: any, state: any) => ({
      ...baseStyles,
      width: "350px",
    }),
    control: (provided: any, state: any) => ({
      ...provided,
      width: "140px",
      fontSize: "17px",
    }),
    container: (provided: any) => ({
      ...provided,
      width: 365,
      position: "absolute",
    }),
  };
  const option: any = countryCode?.map((e) => {
    return {
      label: `${e.flag} ${e.name}(${e.dial_code})`,
      value: e.dial_code,
    };
  });

  const handleCheckBox = () => {
    setCheckBox(!checkBox);
  };

  const handleCountryCode = (mode: any) => {
    setCountryDialCode({
      label: `${mode?.label?.split("").slice(0, 4).join("")} (${mode?.value})`,
      value: mode?.value,
    });
  };

  const handleMaxLengthCheck = (e: any) => {
    if (e?.target.value.length > e?.target.maxLength) {
      e.target.value = e.target.value.slice(0, e.target.maxLength);
      setInputDetails((prev: any) => ({
        ...prev,
        otp: e?.target.value,
      }));
    }
  };
  const handleSendOtp = () => {
    setShowOtpVerification(true);
    let finalData = {
              countryCode: countryDialCode?.value,
              mobileNumber: inputDetails?.mobileNumber
          }
    onNext(finalData);
  };
  return (
    <div className="pb-4" style={{ borderBottom: "1px solid #bfcbe1" }}>
      <div>
        <label className="mb-2">Mobile number</label>
        <div
          className="phone-number-container-signup"
          style={{ marginBottom: "10px", position:'relative' }}
        >
          <div style={{ marginLeft: "-12px" }}>
            <DropDown
              options={option}
              value={countryDialCode}
              handleChange={handleCountryCode}
              style={selectStyle}
              disabled
            />
          </div>
          <div className="phone-number-input"
          >
            <input
              type="number"
              className="form-control"
              name="phone"
              value={inputDetails?.mobileNumber}
              autoFocus
              onChange={handleInputChange}
              onWheel={(event) => event.currentTarget.blur()}
              maxLength={10}
              onInput={handleMaxLengthCheck}
            />
            {/* {true
                                    mobileFetching && inputDetails?.mobileNumber
                                     && <RollingLoader />} */}
            {mobileFetching && inputDetails?.mobileNumber && (
              <div style={{position:"absolute", top:"0", right:'0'}}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  style={{
                    margin: "auto",
                    background: "none",
                    display: "block",
                    shapeRendering: "auto",
                  }}
                  width={40}
                  height={40}
                  viewBox="0 0 100 100"
                  preserveAspectRatio="xMidYMid"
                >
                  <circle
                    cx="50"
                    cy="50"
                    fill="none"
                    stroke="#dd4433"
                    stroke-width="5"
                    r="20"
                    stroke-dasharray="94.24777960769379 33.41592653589793"
                  >
                    <animateTransform
                      attributeName="transform"
                      type="rotate"
                      repeatCount="indefinite"
                      dur="1s"
                      values="0 50 50;360 50 50"
                      keyTimes="0;1"
                    ></animateTransform>
                  </circle>
                </svg>
              </div>
            )}
          </div>
        </div>
        {inputDetails?.mobileNumber &&
        isMobileNo === 1 &&
        mobileMessage?.includes("mobile") ? (
          <small
            className="text-danger"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            Mobile number is already in use!
          </small>
        ) : (
          ""
        )}
        <div className="d-flex mt-4">
          <span className="mt-1">
            <Checkbox checked={checkBox} onPress={handleCheckBox} />
          </span>
          <span className="ml-2">
            I agree to the{" "}
            <a
              style={{
                color: "#dd4433",
                textDecoration: "underline",
                textUnderlineOffset: "2px",
              }}
              href="https://akssai.com/terms-conditions/"
              target="_blank"
            >
              Terms of Service
            </a>{" "}
            and{" "}
            <a
              style={{
                color: "#dd4433",
                textDecoration: "underline",
                textUnderlineOffset: "2px",
              }}
              href="https://akssai.com/privacy-policy/"
              target="_blank"
            >
              Privacy Policy
            </a>
          </span>
        </div>
        <div className="mb-3 mt-3">
          <button
            type="submit"
            className="btn btn-primary w-100"
            disabled={!inputDetails?.mobileNumber || !checkBox || mobileMessage?.includes("mobile")}
            onClick={handleSendOtp}
          >
            Get OTP
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateAccountWithOtp;
